import Vue from 'vue'

export default {
  setDocumentsList(state, data) {
    state.documentsList = data
  },
  setReportsList(state, data) {
    state.reportsList = data
  },
  setDocumentUploadingProgress(state, data) {
    state.documentUploadingProgress = data
  },
}



// WEBPACK FOOTER //
// ./src/store/documents/mutations.js